import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  duration: 6000,
  position: 'top-center',
  keepOnHover: true,
});
